'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _FirstPage = require('@material-ui/icons/FirstPage');
var _FirstPage2 = _interopRequireDefault(_FirstPage);
var _ChevronLeft = require('@material-ui/icons/ChevronLeft');
var _ChevronLeft2 = _interopRequireDefault(_ChevronLeft);
var _ChevronRight = require('@material-ui/icons/ChevronRight');
var _ChevronRight2 = _interopRequireDefault(_ChevronRight);
var _LastPage = require('@material-ui/icons/LastPage');
var _LastPage2 = _interopRequireDefault(_LastPage);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  Paginator: {
    marginTop: 16,
    display: 'flex',
    justifyContent: 'center'
  },
  enabled: {
    cursor: 'pointer'
  },
  disabled: {
    color: 'rgba(0, 0, 0, 0.4)'
  }
};
var Paginator = function (_Component) {
  _inherits(Paginator, _Component);
  function Paginator() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Paginator);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Paginator.__proto__ || Object.getPrototypeOf(Paginator)).call.apply(_ref, [this].concat(args))), _this), _this.fetchPage = function (page) {
      var _this$props = _this.props,
        parentRef = _this$props.parentRef,
        fetchPage = _this$props.fetchPage;
      fetchPage(page);
      if (!!parentRef && !!parentRef.current) parentRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Paginator, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        classes = _props.classes,
        first = _props.first,
        prev = _props.prev,
        self = _props.self,
        next = _props.next,
        last = _props.last,
        fetchPage = _props.fetchPage;
      var firstDisabled = !first || first === self;
      var prevDisabled = !prev;
      var nextDisabled = !next;
      var lastDisabled = !last || last === self;
      return _react2.default.createElement('div', {
        className: classes.Paginator
      }, _react2.default.createElement(_FirstPage2.default, {
        onClick: function onClick() {
          return !firstDisabled && _this2.fetchPage(first);
        },
        className: firstDisabled ? classes.disabled : classes.enabled
      }), _react2.default.createElement(_ChevronLeft2.default, {
        onClick: function onClick() {
          return !prevDisabled && _this2.fetchPage(prev);
        },
        className: prevDisabled ? classes.disabled : classes.enabled
      }), _react2.default.createElement(_ChevronRight2.default, {
        onClick: function onClick() {
          return !nextDisabled && _this2.fetchPage(next);
        },
        className: nextDisabled ? classes.disabled : classes.enabled
      }), _react2.default.createElement(_LastPage2.default, {
        onClick: function onClick() {
          return !lastDisabled && _this2.fetchPage(last);
        },
        className: lastDisabled ? classes.disabled : classes.enabled
      }));
    }
  }]);
  return Paginator;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(Paginator);